var map = {
	"./main/agentes/agentes.module": [
		"./src/app/main/agentes/agentes.module.ts",
		"default~main-agentes-agentes-module~main-clientes-clientes-module~main-coberturas-coberturas-module~~165334db",
		"common",
		"main-agentes-agentes-module"
	],
	"./main/autenticacion/autenticacion.module": [
		"./src/app/main/autenticacion/autenticacion.module.ts",
		"main-autenticacion-autenticacion-module"
	],
	"./main/captura/captura.module": [
		"./src/app/main/captura/captura.module.ts",
		"default~main-captura-captura-module~main-consulta-consulta-module~main-interfaces-interfaces-module~~a9a0474b",
		"default~main-captura-captura-module~main-consulta-consulta-module~main-reportes-reportes-module",
		"common",
		"main-captura-captura-module"
	],
	"./main/clientes/clientes.module": [
		"./src/app/main/clientes/clientes.module.ts",
		"default~main-agentes-agentes-module~main-clientes-clientes-module~main-coberturas-coberturas-module~~165334db",
		"common",
		"main-clientes-clientes-module"
	],
	"./main/coberturas/coberturas.module": [
		"./src/app/main/coberturas/coberturas.module.ts",
		"default~main-agentes-agentes-module~main-clientes-clientes-module~main-coberturas-coberturas-module~~165334db",
		"common",
		"main-coberturas-coberturas-module"
	],
	"./main/companias/companias.module": [
		"./src/app/main/companias/companias.module.ts",
		"default~main-agentes-agentes-module~main-clientes-clientes-module~main-coberturas-coberturas-module~~165334db",
		"common",
		"main-companias-companias-module"
	],
	"./main/consulta/consulta.module": [
		"./src/app/main/consulta/consulta.module.ts",
		"default~main-captura-captura-module~main-consulta-consulta-module~main-interfaces-interfaces-module~~a9a0474b",
		"default~main-captura-captura-module~main-consulta-consulta-module~main-reportes-reportes-module",
		"common",
		"main-consulta-consulta-module"
	],
	"./main/grupos/grupos.module": [
		"./src/app/main/grupos/grupos.module.ts",
		"default~main-agentes-agentes-module~main-clientes-clientes-module~main-coberturas-coberturas-module~~165334db",
		"common",
		"main-grupos-grupos-module"
	],
	"./main/interfaces/interfaces.module": [
		"./src/app/main/interfaces/interfaces.module.ts",
		"default~main-captura-captura-module~main-consulta-consulta-module~main-interfaces-interfaces-module~~a9a0474b",
		"common",
		"main-interfaces-interfaces-module"
	],
	"./main/ramos/ramos.module": [
		"./src/app/main/ramos/ramos.module.ts",
		"default~main-agentes-agentes-module~main-clientes-clientes-module~main-coberturas-coberturas-module~~165334db",
		"common",
		"main-ramos-ramos-module"
	],
	"./main/reportes/reportes.module": [
		"./src/app/main/reportes/reportes.module.ts",
		"default~main-captura-captura-module~main-consulta-consulta-module~main-interfaces-interfaces-module~~a9a0474b",
		"default~main-captura-captura-module~main-consulta-consulta-module~main-reportes-reportes-module",
		"common",
		"main-reportes-reportes-module"
	],
	"./main/sucursales/sucursales.module": [
		"./src/app/main/sucursales/sucursales.module.ts",
		"default~main-agentes-agentes-module~main-clientes-clientes-module~main-coberturas-coberturas-module~~165334db",
		"common",
		"main-sucursales-sucursales-module"
	],
	"./main/tipocambio/tipocambio.module": [
		"./src/app/main/tipocambio/tipocambio.module.ts",
		"default~main-agentes-agentes-module~main-clientes-clientes-module~main-coberturas-coberturas-module~~165334db",
		"common",
		"main-tipocambio-tipocambio-module"
	],
	"./main/utilerias/utilerias.module": [
		"./src/app/main/utilerias/utilerias.module.ts",
		"main-utilerias-utilerias-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;